import {AppIdSchema} from '@cohort/shared/schema/apps';
import {BooleanQueryStringSchema, DateSchema} from '@cohort/shared/schema/common';
import {PaginationParamsSchema} from '@cohort/shared/schema/common/pagination';
import {
  UserPropertyDataTypeSchema,
  UserPropertyNameSchema,
} from '@cohort/shared/schema/common/userProperty';
import {z} from 'zod';

export const UserPropertyASchema = z.object({
  id: z.string().uuid(),
  appId: AppIdSchema.nullable(),
  name: UserPropertyNameSchema,
  referenceId: z.string(),
  dataType: UserPropertyDataTypeSchema,
  createdAt: DateSchema,
  updatedAt: DateSchema,
});
export type UserPropertyADto = z.infer<typeof UserPropertyASchema>;

// Create User Property
export const CreateUserPropertyDataASchema = z.object({
  name: UserPropertyNameSchema,
  dataType: UserPropertyDataTypeSchema,
  referenceId: z
    .string()
    .optional()
    .transform(value => (value === '' ? undefined : value)),
});
export type CreateUserPropertyDataADto = z.infer<typeof CreateUserPropertyDataASchema>;

// Update User Property
export const UpdateUserPropertyDataASchema = z.object({
  name: UserPropertyNameSchema.optional(),
  referenceId: z.string().optional(),
});
export type UpdateUserPropertyDataADto = z.infer<typeof UpdateUserPropertyDataASchema>;

// List User Properties
export const ListUserPropertiesParamsASchema = PaginationParamsSchema.extend({
  search: z.string().min(1).optional(),
  appId: AppIdSchema.optional(),
  hasAppId: BooleanQueryStringSchema.optional(),
});

export type ListUserPropertiesParamsADto = z.infer<typeof ListUserPropertiesParamsASchema>;

export const CheckReferenceIdAvailabilityResponseASchema = z.object({
  available: z.boolean(),
});
export type CheckReferenceIdAvailabilityResponseADto = z.infer<
  typeof CheckReferenceIdAvailabilityResponseASchema
>;

// Check Reference Id Availability
export const GetReferenceIdAvailabilityParamsASchema = z.object({
  referenceId: z.string().min(1),
  appId: AppIdSchema.optional(),
});
export type GetReferenceIdAvailabilityParamsADto = z.infer<
  typeof GetReferenceIdAvailabilityParamsASchema
>;
